import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetHotel, useUpdateHotel } from "@/hooks/hotels";
import { CreateHotel, Hotel } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(hotels)/hotels/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetHotel(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Hotel }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateHotel({
    onSuccess: (hotel) => {
      navigate({
        to: "/hotels",
        params: { id: hotel.id.toString() },
      });
    },
  });

  const update = async (hotel: CreateHotel) => {
    await mutateAsync({ id: model.id, ...hotel });
  };
  return <Form model={model} onUpsert={update} />;
}
